import clsx from 'clsx';
import React from 'react';

import styles from './CoinCheckableConsentTitle.module.scss';

interface ICoinCheckableConsentTitleProps {
  title: string | React.ReactNode;
  checked: boolean;
  setCallback: (checked: boolean) => void;
  id: string;
  hideCheckBox?: boolean;
}

const CoinCheckableConsentTitle: React.FC<ICoinCheckableConsentTitleProps> = ({
  title,
  checked,
  setCallback,
  id,
  hideCheckBox,
}) => {
  return (
    <article className={styles.agree}>
      <input
        className={clsx(styles.input, checked && styles.checked)}
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => {
          e.stopPropagation();
          setCallback(e.target.checked);
        }}
      />
      <label className={styles.label} htmlFor={id}>
        {!hideCheckBox && <i className={styles.checkbox} />}
        <span>{title}</span>
      </label>
    </article>
  );
};

export default CoinCheckableConsentTitle;
